<template>
  <svg width="16" height="20" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.00018 0C6.89561 0 6.00018 0.895431 6.00018 2V2.34141C3.66979 3.16508 2.00018 5.38756 2.00018 8V13L0.518409 15.2226C0.296891 15.5549 0.535087 16 0.934434 16H15.0659C15.4653 16 15.7035 15.5549 15.4819 15.2227L14.0002 13V8C14.0002 5.38756 12.3306 3.16508 10.0002 2.34141V2C10.0002 0.895431 9.10475 0 8.00018 0ZM8.00024 20C9.48747 20 10.7219 18.9178 10.9591 17.4979C11.0046 17.2255 10.7764 17 10.5002 17H5.50024C5.2241 17 4.99587 17.2255 5.04137 17.4979C5.27854 18.9178 6.51301 20 8.00024 20Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'Union',
};
</script>
